import type { BusinessType, ModuleType } from '../types/index.js';

export interface ModuleDefinition {
  type: ModuleType;
  label: string;
  description: string;
  defaultEnabled: boolean;
  paid?: boolean;
}

export const MODULE_REGISTRY: Record<ModuleType, ModuleDefinition> = {
  'business-info': {
    type: 'business-info',
    label: 'Business Info',
    description: 'Name, phone, address, social links',
    defaultEnabled: true,
  },
  hero: {
    type: 'hero',
    label: 'Hero Banner',
    description: 'Full-width banner image with headline and call to action',
    defaultEnabled: false,
  },
  menu: {
    type: 'menu',
    label: 'Menu',
    description: 'Food and drink items with prices',
    defaultEnabled: false,
  },
  hours: {
    type: 'hours',
    label: 'Hours',
    description: 'Open and close times per day',
    defaultEnabled: true,
  },
  gallery: {
    type: 'gallery',
    label: 'Gallery',
    description: 'Photos of your business',
    defaultEnabled: false,
  },
  announcement: {
    type: 'announcement',
    label: 'Announcement',
    description: 'Banner for promotions or news',
    defaultEnabled: false,
  },
  services: {
    type: 'services',
    label: 'Services',
    description: 'Services offered with prices',
    defaultEnabled: false,
  },
};

export const BUSINESS_TYPE_PRESETS: Record<
  BusinessType,
  { defaultModules: ModuleType[]; defaultTheme: string; label: string }
> = {
  restaurant: {
    label: 'Restaurant',
    defaultModules: ['business-info', 'menu', 'hours', 'gallery', 'announcement'],
    defaultTheme: 'restaurant-1',
  },
  barbershop: {
    label: 'Barbershop',
    defaultModules: ['business-info', 'services', 'hours', 'gallery'],
    defaultTheme: 'restaurant-1',
  },
  plumber: {
    label: 'Plumber',
    defaultModules: ['business-info', 'services', 'hours'],
    defaultTheme: 'restaurant-1',
  },
  general: {
    label: 'General Business',
    defaultModules: ['business-info', 'hours'],
    defaultTheme: 'restaurant-1',
  },
};
